'use client'

import React from 'react'

import { Box, Text } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import {
  metadataCardStyles,
  metadataRowLabelStyles,
  metadataRowStyles,
  metadataRowValueStyles,
  metadataTitleStyles,
} from './ReasoningTrail.styles'
import type { ReasoningTrailMetadata } from './types'

type ReasoningTrailMetadataCardProps = {
  metadataCard: ReasoningTrailMetadata
  colorScheme: ColorScheme
}

/**
 * Generic label/value evidence renderer — the same shape serves every source
 * type. Renders `title` + `rows[] {label, value}`.
 */
export const ReasoningTrailMetadataCard = ({
  metadataCard,
  colorScheme,
}: ReasoningTrailMetadataCardProps) => (
  <Box {...metadataCardStyles(colorScheme)}>
    <Text {...metadataTitleStyles(colorScheme)}>{metadataCard.title}</Text>
    {metadataCard.rows.map((row, index) => (
      <Box key={`${row.label}-${index}`} {...metadataRowStyles}>
        <Text {...metadataRowLabelStyles(colorScheme)}>{row.label}</Text>
        <Text {...metadataRowValueStyles(colorScheme)}>{row.value}</Text>
      </Box>
    ))}
  </Box>
)
